<template>
  <v-container>
    <v-layout row wrap>
      <!-- <v-flex xs12 md4> -->
      <!-- <v-select
          name="broker"
          v-bind:label="$t('message.aps')"
          v-validate="'required'"
          :error-messages="errors.collect('broker')"
          item-text="code"
          item-value="value"
          :items="broker"
          v-model="e3Broker"
      ></v-select>-->
      <!-- <v-autocomplete
          
        :items="brokerRenovations"
          :filter="customFilter"
          color="white"
          item-text="Descripcion"
          item-value="IdApsSos"
          name="broker"
          :label="$t('message.aps')"
          v-validate="'required'"
          :error-messages="errors.collect('broker')"
          v-model="e3BrokerRenovations"
        >
          <template slot="selection" slot-scope="data">
            <div>
              <span style="color:#005cae">{{data.item.Descripcion}}</span>
            </div>
          </template>
      </v-autocomplete>-->
      <!--  </v-flex> -->
      <v-flex xs12 md6>
        <v-select
          name="yearCommercial"
          v-bind:label="$t('message.yearCommercial')"
          v-validate="'required'"
          :error-messages="errors.collect('yearCommercial')"
          item-text="Valor"
          :items="yearCommercialRenovations"
          v-model="e6yearCommercialRenovations"
        >
          <!-- 
          <template slot="selection" slot-scope="{ item, index }">
            <span style="color:#005cae">{{ item }}</span>
          </template>-->
        </v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select
          name="indicator"
          v-bind:label="$t('message.indicator')"
          v-validate="'required'"
          :error-messages="errors.collect('indicator')"
          :items="catalogIndicatorsRenovations"
          item-text="value"
          item-value="code"
          v-model="e1IndicatorsRenovations"
        >
          <!-- 
          <template slot="selection" slot-scope="{ item, index }">
            <span style="color:#005cae">{{ item.value }}</span>
          </template>-->
        </v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select
          name="startWeek"
          v-bind:label="$t('message.startWeek')"
          v-validate="'required'"
          :error-messages="errors.collect('startWeek')"
          item-text="Valor"
          :items="startWeekRenovations"
          v-model="e4startWeekRenovations"
        >
          <!-- 
          <template slot="selection" slot-scope="{ item, index }">
            <span style="color:#005cae">{{ item }}</span>
          </template>-->
        </v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select
          name="endWeek"
          v-bind:label="$t('message.endWeek')"
          v-validate="'required'"
          :error-messages="errors.collect('endWeek')"
          item-text="Valor"
          :items="endWeekRenovations"
          v-model="e5endWeekRenovations"
        >
          <!-- 
          <template slot="selection" slot-scope="{ item, index }">
            <span style="color:#005cae">{{ item }}</span>
          </template>-->
        </v-select>
      </v-flex>      

      <v-flex xs12 md6>
        <!-- <v-select
          name="branchOffices"
          v-bind:label="$t('message.branchOffices')"
          v-validate="'required'"
          :error-messages="errors.collect('branchOffices')"
          :items="branchOfficesRenovations"
          item-text="NombreAgencia"
          item-value="IdAgencia"
          v-model="e2BranchOfficesRenovations"
        >
          <template slot="selection" slot-scope="{ item, index }">
            <span style="color:#005cae">{{ item.NombreAgencia }}</span>
          </template> 
        </v-select>-->
        <label
          style="color: rgb(149, 149, 149);!important;font-size: 16px;
              line-height: 1;
              min-height: 8px;font-weight: 400;"
        >Sucursales</label>
        <v-radio-group
          name="branchOffices"
          v-validate="'required'"
          :error-messages="errors.collect('branchOffices')"
          v-model="branchOfficesRenovations"
          :mandatory="false"
        >
          <v-radio label="Todas" value="0"></v-radio>
          <v-radio label="Sucursal Actual" value="1"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-flex v-if="showGraphicRenovations" class="row">
      <v-flex class="md8 lg8" offset-md2 offset-lg2>
        <chart-weekly-budget-compliance
          :chartData="datasetsRenovations"
          :options="optionsRenovations"
        ></chart-weekly-budget-compliance>
      </v-flex>
    </v-flex>
    <v-flex class="row pt-4">
      <h3 class="subheading text--secondary">{{$t('message.analysisRenovations')}}</h3>
      <v-layout>
        <v-flex text-lg-left>
          <v-btn class="ml-0" flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex text-lg-right>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :search="search"
        class="v-table-list theme--light"
        :items="table1Renovations"
        :headers="headerAnalysisRenovations"
      >
        <template slot="items" scope="props">
          <td class="text-xs-left cut-text">{{ props.item.Column1 }}</td>
          <td class="text-xs-left cut-text">$ {{ props.item.Column2 }}</td>
          <td class="text-xs-left cut-text">$ {{ props.item.Column3 }}</td>
          <td class="text-xs-left cut-text">{{ props.item.Column4 }}%</td>
          <td class="text-xs-left cut-text">$ {{ props.item.Column5 }}</td>
          <td class="text-xs-left cut-text">{{ props.item.Column6 }}%</td>
        </template>
        <template slot="no-data">
          <div>{{$t('message.noRecords')}}</div>
        </template>
        <template
          slot="pageText"
          slot-scope="props"
        >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>
      </v-data-table>
    </v-flex>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";
import { Validator } from "vee-validate";
import DatePicker from "@/components/DatePicker/DatePicker";

import ChartWeeklyBudgetCompliance from "./ChartWeeklyBudgetCompliance.vue";

import CatalogServices from "@/services/CatalogsServices";
import ComunServices from "@/services/ComunServices";

import CommercialGraphicsServices from "@/services/CommercialGraphicsServices";
import { EventBus } from "@/imports/EventBus";

export default {
  components: {
    ChartWeeklyBudgetCompliance,
    DatePicker
  },
  computed: {
    ...mapGetters(["agency","userProfile","agencyId"])
  },
  beforeDestroy() {
    EventBus.$off("AnalysisRenovations");
  },
  mounted() {
    this.getCatalogInfo();
    EventBus.$on("AnalysisRenovations", () => {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.$nextTick(() => {
            this.showGraphicRenovations = false;
            this.getDataFromApiRenovations();
          });
        }
      });
    });
  },
  methods: {
    filterSearch(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: val
      });
    },
    nzDate: nzDate,
    refresh() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.$nextTick(() => {
            this.showGraphicRenovations = false;
            this.table1Renovations = [];
            this.getDataFromApiRenovations();
          });
        }
      });
    },
    getCatalogInfo() {
      /* ComunServices.getAgencies()
        .then(response => {
          
          this.branchOfficesRenovations = response.data.data.Data;
        })
        .catch(res => {
          this.$root.$emit(
            "showSnackBar",
            "No se ha podido cargar las sucursales",
            "error"
          );
        });

      ComunServices.getAgents()
        .then(response => {
          this.brokerRenovations = response.data.data.Data;
        })
        .catch(res => {
          this.$root.$emit(
            "showSnackBar",
            "No se ha podido cargar APS",
            "error"
          );
        }); */
      CatalogServices.getIndicators()
        .then(response => {
          this.catalogIndicatorsRenovations = response.data.data;
        })
        .catch(res => {
          this.$root.$emit("showSnackBar", "Error desconocido", "error");
        });
    },
    getDataFromApiRenovations() {
      this.$root.$emit("showLoading", "Cargando análisis de renovaciones");

      let agencyId = "";
      if (this.branchOfficesRenovations == "1") {
        agencyId = this.agencyId;
      } else {
        agencyId = 0;
      }
      this.e3BrokerRenovations = this.userProfile.id_aps_vt;
      CommercialGraphicsServices.getRenewalAnalysisGraphic(
        this.e3BrokerRenovations,
        this.e6yearCommercialRenovations,
        this.e4startWeekRenovations,
        this.e5endWeekRenovations,
        this.e1IndicatorsRenovations,
        agencyId
        /*  this.e2BranchOfficesRenovations */
      ).then(res => {
        //console.log(res)
        this.$nextTick(() => {
          let dataResponse = res.data.data.Data;
          if (
            typeof res.data.data.Error != "undefined" &&
            res.data.data.Data == null
          ) {
            this.$root.$emit("hideLoading");
            this.$root.$emit("showSnackBar", res.data.data.Msg, "error");
          }
          if (dataResponse.Grafico[0] != null && dataResponse != null) {
            this.labelsRenovations = dataResponse.Grafico[3].Data;
            this.renderGraphicRenovations = false;
            this.dataFromGraphicRenovations = [
              {
                label: dataResponse.Grafico[1].Label,
                borderColor: "#e81506",
                pointBackgroundColor: "white",
                pointBorderColor: "#e81506",
                borderWidth: 1,
                backgroundColor: "rgba(234, 21, 6, 0.5)",
                data: dataResponse.Grafico[1].Data
              },
              {
                label: dataResponse.Grafico[2].Label,
                borderColor: "#e86406",
                pointBackgroundColor: "white",
                pointBorderColor: "#e86406",
                borderWidth: 1,
                backgroundColor: "rgba(234, 101, 6, 0.5)",
                data: dataResponse.Grafico[2].Data
              },
              {
                label: dataResponse.Grafico[0].Label,
                borderColor: "#0695e8",
                pointBackgroundColor: "white",
                borderWidth: 1,
                pointBorderColor: "#0695e8",
                backgroundColor: "rgba(6, 150, 234, 0.2)",
                data: dataResponse.Grafico[0].Data
              }
            ];
            this.xAxesRenovations = [
              {
                scaleLabel: {
                  display: true,
                  labelString: dataResponse.Grafico[3].Label,
                  fontFamily: "Roboto",
                  fontSize: 14
                }
              }
            ];

            this.yAxesRenovations = [
              {
                ticks: {
                  callback: function(value, index, values) {
                    return value.toLocaleString();
                  }
                },
                scaleLabel: {
                  display: true,
                  labelString: "Valores",
                  fontFamily: "Roboto",
                  fontSize: 14
                }
              }
            ];
            let el = this;
            this.table1Renovations = dataResponse.Tabla1;
            this.optionsRenovations = {
              responsive: true,
              maintainAspectRatios: false,
              scales: {
                yAxes: this.yAxesRenovations,
                xAxes: this.xAxesRenovations
              },
              tooltips: {
                mode: "index",
                fontFamily: "Roboto",
                callbacks: {
                  title: function(tooltipItem, data) {
                    return (
                      el.xAxesRenovations[0].scaleLabel.labelString +
                      " : " +
                      data.labels[tooltipItem[0].index]
                    );
                  },

                  label: function(tooltipItem, data) {
                    return (
                      data.datasets[tooltipItem.datasetIndex].label +
                      ":" +
                      tooltipItem.yLabel.toLocaleString()
                    );
                  }
                }
              },
              annotation: this.annotation
            };
            this.datasetsRenovations = {
              labels: this.labelsRenovations,
              datasets: this.dataFromGraphicRenovations
            };
            this.showGraphicRenovations = true;
            this.$root.$emit("hideLoading");
          } else {
            this.$root.$emit("hideLoading");
            this.$root.$emit(
              "showSnackBar",
              "No hay datos que mostrar",
              "accent"
            );
            this.table1Renovations = [];
          }
        });
      });
    },
    customFilter(item, queryText, itemText) {
      if (item.Descripcion != null && item.IdApsSos != null) {
        const textOne = item.Descripcion.toLowerCase();
        const textTwo = item.IdApsSos.toLowerCase();
        const searchText = queryText.toLowerCase();
        return (
          textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
        );
      }
    },

    setFormatNumber(num, symbol) {
      let separator = ".";
      let sepDecimal = ",";
      num += "";
      var splitStr = num.split(".");
      var splitLeft = splitStr[0];
      var splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : "";
      var regx = /(\d+)(\d{3})/;
      while (regx.test(splitLeft)) {
        splitLeft = splitLeft.replace(regx, "$1" + separator + "$2");
      }
      return symbol + splitLeft + splitRight;
    },
    changeSort(column) {
      if (this.paginationRenovations.sortBy === column) {
        this.paginationRenovations.descending = !this.paginationRenovations
          .descending;
      } else {
        this.paginationRenovations.sortBy = column;
        this.paginationRenovations.descending = false;
      }
    },

    setFormatTable(table, restricts) {
      let cont = 0;
      table.forEach(element => {
        for (var property in element) {
          if (property != " " && typeof restricts[property] == "undefined") {
            let str = element[property];
            str = str.replace(",", ".");
            str = this.setFormatNumber(str, "");
            table[cont][property] = str;
          }
        }
        cont++;
      });
    }
  },
  watch: {},
  data() {
    return {
      datasetsRenovations: {},
      optionsRenovations: {},
      renderGraphicRenovations: false,
      dataFromGraphicRenovations: [{}],
      labelsRenovations: [],
      xAxesRenovations: [{}],
      yAxesRenovations: [{}],
      annotationRenovations: [],
      showGraphicRenovations: false,
      table1Renovations: [],
      e3BrokerRenovations: null,
      brokerRenovations: [{}],
      selectedRenovations: [],
      catalogIndicatorsRenovations: [],
      paginationRenovations: {
        sortBy: "date"
      },
      yearCommercialRenovations: [
        "2012",
        "2013",
        "2014",
        "2015",
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
        "2041",
        "2042",
        "2043",
        "2044",
        "2045",
        "2046",
        "2047",
        "2048",
        "2049",
        "2050"
      ],
      e1IndicatorsRenovations: null,
      e2BranchOfficesRenovations: null,
      typeProductionRenovations: [],
      branchOfficesRenovations: "",
      e4startWeekRenovations: null,
      e5endWeekRenovations: null,
      e6yearCommercialRenovations: null,
      startWeekRenovations: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "51",
        "52"
      ],
      endWeekRenovations: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "51",
        "52"
      ],
      analysisRenovationsRenovations: [],
      search: "",
      headerAnalysisRenovations: [
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.week"),
          value: "Column1",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.expected"),
          value: "Column2",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.renovated"),
          value: "Column3",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.percentRenovated"),
          value: "Column4",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.paidOut"),
          value: "Column5",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.percentPaidOut"),
          value: "Column6",
          width: "14%"
        }
      ]
    };
  }
};
</script>
<style>
.v-label.v-label--active.theme--light.white--text {
  color: #005cae !important;
  caret-color: #fff !important;
}
.white--text {
  /* color: #fff !important; */
  color: #005cae !important;
  caret-color: #fff !important;
}
</style>